import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PraiaService {

  getPraia(): Observable<any[]> {
    const items = [
      {
        stars: '4.8',
        name: 'Praia exemplo 1',
        horarioAberto: '05:00 - 22:00',
        possuiEstacionamento: false,
        endereco: 'Rua das Amoras, 126 - Jardim das flores',
        image: '/assets/images/MelhoresPraiasDoBrasil.Prainha.Itacaré.jpg',
        distancia: 2,
        latitude: -23.9871,
        longitude: -46.4123,
      },
      {
        stars: '4.8',
        name: 'Praia exemplo 2',
        horarioAberto: '05:00 - 22:00',
        possuiEstacionamento: false,
        endereco: 'Rua das Amoras, 126 - Jardim das flores',
        image: '/assets/images/praia-escada.jpg',
        distancia: 5,
        latitude: -23.9851,
        longitude: -46.4143,
      },
      {
        stars: '4.8',
        name: 'Praia exemplo 3',
        horarioAberto: '05:00 - 22:00',
        possuiEstacionamento: false,
        endereco: 'Rua das Amoras, 126 - Jardim das flores',
        image: '/assets/images/praias-brasil-sancho.jpg',
        distancia: 3,
        latitude: -23.9831,
        longitude: -46.4163,
      },
      {
        stars: '4.8',
        name: 'Praia exemplo 4',
        horarioAberto: '05:00 - 22:00',
        possuiEstacionamento: false,
        endereco: 'Rua das Amoras, 126 - Jardim das flores',
        image: '/assets/images/sem-imagem.png',
        distancia: 4,
        latitude: -23.9811,
        longitude: -46.4183,
      },
      {
        stars: '4.8',
        name: 'Praia exemplo 5',
        horarioAberto: '05:00 - 22:00',
        possuiEstacionamento: false,
        endereco: 'Rua das Amoras, 126 - Jardim das flores',
        image: '/assets/images/sem-imagem.png',
        distancia: 6,
        latitude: -23.9791,
        longitude: -46.4203,
      },
      {
        stars: '4.8',
        name: 'Praia exemplo 6',
        horarioAberto: '05:00 - 22:00',
        possuiEstacionamento: false,
        endereco: 'Rua das Amoras, 126 - Jardim das flores',
        image: '/assets/images/sem-imagem.png',
        distancia: 7,
        latitude: -23.9771,
        longitude: -46.4223,
      },
    ];

    return of(items);
  }
}
